import { useEffect } from "react";
import { useLang } from "@/lib/i18n";

// Lightweight per-page SEO: title, description, canonical, og/twitter image.
export default function Seo({ title, description }) {
  const { param } = useLang();
  useEffect(() => {
    const full = title ? `${title} · LUMORA` : "LUMORA — A Brighter Future Starts With Education";
    document.title = full;

    const setMeta = (sel, attr, key, content) => {
      if (!content) return;
      let el = document.head.querySelector(`${sel}[${attr}="${key}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, key);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };

    if (description) {
      setMeta("meta", "name", "description", description);
      setMeta("meta", "property", "og:description", description);
      setMeta("meta", "name", "twitter:description", description);
    }
    setMeta("meta", "property", "og:title", full);
    setMeta("meta", "name", "twitter:title", full);

    // canonical
    let link = document.head.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }
    link.setAttribute("href", `${window.location.origin}${window.location.pathname}`);
    document.documentElement.lang = param;
  }, [title, description, param]);

  return null;
}
